<template>
  <div class="container">
    <footer id="app-footer" class="py-3 border-top mt-5">
      <div class="row">
        <div class="col-6 fw-bold text-copyright  d-flex align-items-center">
          جميع الحقوق محفوظة &#169;  
          {{ new Date().getFullYear() }}
        </div>
        <div class="col-6 text-start">
          <img width="80px" src="@/assets/images/2030.png" alt="رؤية 2030" />
        </div>
      </div>
    </footer>
  </div>
</template>


<style lang="scss">
.text-copyright{
  color: #4D6A6F;
}
</style>